import React, { FC } from "react";

import { TabTable } from "./TabTable";
import { TabGraph } from "./TabGraph";
import clsx from "clsx";
// import { TabMap } from "./TabMap";
import { TabGoogleMap } from "./TabGoogleMap";
import { useTranslation } from "react-i18next";

type VisualizationProps = {
  dataSource: any[];
  dataDict: any[];
  resourceName: string;
};

export const Visualization: FC<VisualizationProps> = ({
  dataSource,
  dataDict,
  resourceName,
}) => {
  const { t } = useTranslation();
  const [checked, setChecked] = React.useState(1);

  const tabs = [
    {
      label: t("visualization_page.table"),
      element: (
        <TabTable
          dataSource={dataSource}
          dataDict={dataDict}
          height="calc(100vh - 185px)"
        />
      ),
    },
    {
      label: t("visualization_page.graph"),
      element: (
        <TabGraph
          dataSource={dataSource}
          dataDict={dataDict}
          resourceName={resourceName}
        />
      ),
    },
    // {
    //   label: t('visualization_page.table'),
    //   element: <TabMap dataSource={dataSource} />,
    // },
    {
      label: t("visualization_page.map"),
      element: <TabGoogleMap dataSource={dataSource} />,
    },
  ];

  return (
    <div className={clsx("m-auto w-full px-6")}>
      <div
        className={clsx(
          "w-full flex flex-col p-3 lg:p-6 bg-white border rounded-lg shadow-lg"
        )}
      >
        <div className="flex flex-col">
          <h1 className="font-bold mb-3 lg:mb-6 font-sukhumvit">
            {t("visualization_page.visualization")}
          </h1>

          <div role="tablist" className="tabs tabs-lifted bg-[#f6f6f6] pt-3">
            {tabs.map(({ element, label }, idx) => (
              <React.Fragment key={`${label}-${idx}`}>
                <input
                  type="radio"
                  name="visualization-tabs"
                  role="tab"
                  className="tab font-semibold font-sukhumvit text-[0.60rem]"
                  aria-label={label}
                  defaultChecked={idx === checked}
                  onChange={() => setChecked(idx)}
                />
                <div
                  role="tabpanel"
                  className={clsx(
                    "tab-content bg-base-100 border-t-base-300 p-3 sm:p-6 w-full",
                    idx === 0 && "overflow-auto"
                  )}
                >
                  {checked === idx && element}
                </div>
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
